import { create } from 'zustand'

export interface ConfirmOptions {
  title?: string
  confirmText?: string
  cancelText?: string
  danger?: boolean   // 삭제 등 파괴적 작업 → 빨강 확인 버튼
}

interface ConfirmReq extends ConfirmOptions {
  message: string
  resolve: (ok: boolean) => void
}

interface ConfirmState {
  req: ConfirmReq | null
  open: (req: ConfirmReq) => void
  close: () => void
}

export const useConfirmStore = create<ConfirmState>((set) => ({
  req: null,
  open: (req) => set({ req }),
  close: () => set({ req: null }),
}))

/** 브라우저 기본 confirm() 대체 — 앱 내장 다이얼로그. 어디서든 호출 가능.
 *  사용: if (await confirm('삭제할까요?', { danger: true })) remove.mutate(id) */
export function confirm(message: string, opts: ConfirmOptions = {}): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    useConfirmStore.getState().open({ message, ...opts, resolve })
  })
}
